import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IAcquireLockRequestHeaders,
    IAcquireLockResponse,
    IDeleteLockRequestParams,
} from '../../../entity/interface/iStreamHarness';
import { IStreamHarnessRepository } from '../../repositories/interfaces/iStreamHarnessRepository';

export interface IDeleteLockUseCase {
    execute(params: IDeleteLockRequestParams, headers: IAcquireLockRequestHeaders): Promise<IAcquireLockResponse>;
}

export class DeleteLockUseCase implements IDeleteLockUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get streamHarnessRepo(): IStreamHarnessRepository {
        return container.resolve<IStreamHarnessRepository>(DI.REPOSITORIES.IStreamHarnessRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        params: IDeleteLockRequestParams,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        return await this.streamHarnessRepo.deleteLock(params, headers);
    }
}
